import { render, staticRenderFns } from "./Platform.vue?vue&type=template&id=5d09ad17"
import script from "./Platform.vue?vue&type=script&lang=js"
export * from "./Platform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data0/web/xyadmin.98du.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d09ad17')) {
      api.createRecord('5d09ad17', component.options)
    } else {
      api.reload('5d09ad17', component.options)
    }
    module.hot.accept("./Platform.vue?vue&type=template&id=5d09ad17", function () {
      api.rerender('5d09ad17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/example/components/Dropdown/Platform.vue"
export default component.exports